/* eslint-disable react-hooks/exhaustive-deps */
import { Link, useNavigate, useParams } from 'react-router-dom';
import { RiArrowLeftSLine } from 'react-icons/ri';

import Box from 'components/ui/box';
import { AuthContext, useAuth } from 'context/AuthContext';
import { useState, useEffect, useContext, useRef } from 'react';
import {
  getUserEquipeType,
} from 'services/dashboard.service';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import { getChallengeUser } from 'services/challenges.service';
import { BsCheck } from 'react-icons/bs';
import TabTitle from 'components/tab-title';
import './style.scss';
import { getNamedDates } from 'services/utils';
import SimplifiqueModal from 'components/simplifique-modal';

export default function Challenges() {
  const params = useParams();
  const navigate = useNavigate();

  const [list, setList] = useState<unknown[]>();
  const [optionsCycle, setOptionsCycle] = useState<any>([]);
  const [activeItem, setActiveItem] = useState('');
  const [activeItemObj, setActiveItemObj] = useState<any>({});
  const [userType, setUserType] = useState<any>();

  const [loadingList, setLoadingList] = useState(true);

  const { userInfo } = useAuth();
  const { realCycle } = useContext(AuthContext);

  const [total, setTotal] = useState<number>();
  const [totalCompleted, setTotalCompleted] = useState<number>();

  useEffect(() => {
    async function loadData() {
      if (userInfo?.chave && activeItem) {
        const _userType = await getUserEquipeType();
        setUserType(_userType);

        if (activeItemObj?.date_start <= 1690772400000 && params.id !== 'jogador') {
          navigate('/desafios/jogador');
          return;
        }

        setLoadingList(true);
        const data = await getChallengeUser(activeItem, params.id);
        const _data = data.filter((item: any) => {
          return (
            !(
              userInfo.cad_missao === 0 ||
              (Array.isArray(userInfo?.mad_dupla) &&
                userInfo?.mad_dupla?.length > 0 &&
                userInfo?.mad_dupla?.every((md: any) => typeof md.cad_missao === 'number' && md.cad_missao === 0))
            ) || item._id !== 'DVi7Ajw'
          );
        });

        setTotalCompleted(_data.filter((item: any) => item.completed).length);
        setTotal(_data.length);
        setList(_data);
        setLoadingList(false);
      }
    }

    loadData();
  }, [userInfo, activeItem, params]);

  useEffect(() => {
    if (!realCycle) return;

    const cycleOptions = realCycle
      .filter((item: any) => item?.date_start >= 1690772400000)
      .map((cycle: any) => {
        cycle.label = 'Ciclo ' + cycle.title;
        cycle.value = cycle._id;

        return cycle;
      });

    setOptionsCycle(cycleOptions);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [realCycle]);

  function calculatePercentage(percentage: number | null, totalValue: number): number {
    if (!percentage) {
      return 0;
    }
    const calculatedValue = (totalValue / 100) * percentage;
    return Math.floor(calculatedValue);
  }

  function verifyRules(item: any): number {
    if (!item?.progress) {
      return 0;
    }

    if (item?.progress?.rules?.length && item?.progress?.rules?.length <= 2 && item?.progress?.rules[0]?.times_completed) {
      return item?.progress?.rules[0]?.times_completed;
    }

    if (item?.progress?.percent_completed) {
      return calculatePercentage(item?.progress?.percent_completed, getTotal(item));
    }

    return 0;
  }

  function getTotal(item: any) {
    if (item?.extra?.total) return item?.extra?.total;

    if (item?.progress?.rules?.length) return item?.progress?.rules?.length;

    return 1;
  }

  function getProgressText(item: any): string {
    const completed = item.completed ? getTotal(item) : verifyRules(item);
    const totalItems = getTotal(item);
    return `${completed} de ${totalItems} ${item.completed ? 'concluído' : 'em andamento'}`;
  }

  const tabPanelRef = useRef<HTMLUListElement>(null);

  const handleTabClick = (path: string) => {
    navigate(path);
    setTimeout(() => {
      if (tabPanelRef.current) tabPanelRef.current.focus();
    }, 0);
  };

  return (
    <>
      <SimplifiqueModal />
      <main className="mx-auto container p-3 lg:p-10 overflow-hidden" aria-busy={loadingList}>
        <div className="space-y-7 md:space-y-0 md:flex justify-between items-center mb-3 lg:mb-10">
          <nav className="flex flex-ro items-center space-x-3 lg:space-x-1" aria-label="Navegação da página">
            <Link
              to="../"
              className="rounded-full bg-purple flex justify-center items-center p-1"
              aria-label="Voltar para página anterior"
            >
              <RiArrowLeftSLine size={28} className="text-white" aria-hidden="true" />
            </Link>

            <h1 className="text-lg lg:text-3xl py-1 px-6 rounded-full">Lista de desafios</h1>
          </nav>
        </div>

        {params?.id !== 'colaboracao' && params?.id !== 'acao' && (
          <section aria-label="Informações de bonificação">
            {activeItemObj.date_end <= 1725159599999 ? (
              <Box className="mb-5">
                <div className="w-full space-y-5">
                  <p className="text-yellow">Bonificação para desafios concluídos ao final do ciclo:</p>

                  <p>
                    <strong>5 desafios</strong>: 100 pontos <br className="lg:hidden" /> <span className="hidden lg:inline">|</span>{' '}
                    <strong>8 desafios</strong>: 200 pontos <br className="lg:hidden" /> <span className="hidden lg:inline">|</span>{' '}
                    <strong>10 desafios</strong>: 300 pontos
                  </p>
                </div>
              </Box>
            ) : (
              <Box className="mb-5">
                <div className="w-full space-y-5">
                  <p className="text-yellow">Bonificação para desafios concluídos ao final do ciclo:</p>

                  {params?.id === 'gestor' && activeItemObj.date_start > 1730084400000 ? (
                    <p>
                      <strong>9 desafios</strong> = 200 pontos
                    </p>
                  ) : (
                    <p>
                      <strong>5 desafios</strong> = 200 pontos
                    </p>
                  )}
                </div>
              </Box>
            )}
          </section>
        )}

        {params?.id === 'acao' && activeItemObj?.date_start >= getNamedDates().ciclo_2S2025 && (
          <section aria-label="Informações de bonificação">
            <Box className="mb-5">
              <div className="w-full space-y-5">
                <p className="text-yellow">Bonificação para desafios concluídos até o final do prazo: de 01 de julho até 31 de dezembro de 2025</p>

                <p>
                  <strong>Recebe no máximo 1000 pontos</strong>
                </p>
              </div>
            </Box>
          </section>
        )}

        {activeItemObj?.date_start >= 1741575600000 ||
        (userType?._id &&
          !!userInfo &&
          (userInfo.cad_missao === 0 ||
            (Array.isArray(userInfo?.mad_dupla) &&
              userInfo?.mad_dupla?.length > 0 &&
              userInfo?.mad_dupla?.every((md: any) => typeof md.cad_missao === 'number' && md.cad_missao === 0))) &&
          activeItemObj?.date_start >= 1706886000000) ? (
          <nav
            className="rounded-xl overflow-hidden items-center justify-between mb-12 hidden lg:flex"
            aria-label="Categorias de desafios"
            role="tablist"
          >
            <button
              role="tab"
              aria-selected={params?.id === 'jogador'}
              aria-controls="challenge-list"
              tabIndex={0}
              className={`${params?.id === 'jogador' ? 'bg-slate-blue' : 'bg-maastricht-blue'} w-full h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow`}
              onClick={() => handleTabClick('/desafios/jogador')}
              id="tab-jogador"
            >
              Desafios de Funcionários
            </button>

            {(userInfo?.cad_missao === 0 ||
              (Array.isArray(userInfo?.mad_dupla) &&
                userInfo?.mad_dupla &&
                userInfo?.mad_dupla?.length > 0 &&
                userInfo?.mad_dupla?.every((md: any) => typeof md.cad_missao === 'number' && md.cad_missao === 0))) && (
              <button
                role="tab"
                aria-selected={params?.id === 'gestor'}
                aria-controls="challenge-list"
                tabIndex={0}
                className={`${params?.id === 'gestor' ? 'bg-slate-blue' : 'bg-maastricht-blue'} w-full h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow`}
                onClick={() => handleTabClick('/desafios/gestor')}
                id="tab-gestor"
              >
                Desafios da Liderança
              </button>
            )}

            {activeItemObj?.date_start >= getNamedDates().ciclo_1S2025 &&
              activeItemObj?.date_start <= getNamedDates().ciclo_1S2025 && (
                <button
                  role="tab"
                  aria-selected={params?.id === 'acao'}
                  aria-controls="challenge-list"
                  tabIndex={0}
                  className={`${params?.id === 'acao' ? 'bg-slate-blue' : 'bg-maastricht-blue'} w-full h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow`}
                  onClick={() => handleTabClick('/desafios/acao')}
                  id="tab-acao"
                >
                  Arraiá do Reconhecimento
                </button>
              )}

            {activeItemObj?.date_start >= getNamedDates().ciclo_2S2025 &&
              activeItemObj?.date_start <= getNamedDates().ciclo_2S2025 && (
                <button
                  role="tab"
                  aria-selected={params?.id === 'acao'}
                  aria-controls="challenge-list"
                  tabIndex={0}
                  className={`${params?.id === 'acao' ? 'bg-slate-blue' : 'bg-maastricht-blue'} w-full h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow`}
                  onClick={() => handleTabClick('/desafios/acao')}
                  id="tab-acao"
                >
                  Campanhas
                </button>
              )}

            {userType?.has_hybrid_on_team && (
              <button
                role="tab"
                aria-selected={params?.id === 'colaboracao'}
                aria-controls="challenge-list"
                tabIndex={0}
                className={`${params?.id === 'colaboracao' ? 'bg-slate-blue' : 'bg-maastricht-blue'} w-full h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow`}
                onClick={() => handleTabClick('/desafios/colaboracao')}
                id="tab-colaboracao"
              >
                Colaboração
              </button>
            )}
          </nav>
        ) : null}

        <div className={`${params?.id === 'colaboracao' || params?.id === 'acao' ? 'hidden' : ''}`}>
          <TabTitle
            options={optionsCycle}
            title={<p>Realize os desafios do ciclo e ganhe pontos extras em seu saldo</p>}
            onCallBack={e => {
              setActiveItem(e.value);
              setActiveItemObj(e);
            }}
          />

          <div className="-mt-12 mb-12">
            <p className="text-[19px]">
              Total de desafios concluídos:{' '}
              <strong className="text-yellow" aria-label={`${totalCompleted} de ${total} desafios concluídos`}>
                {totalCompleted}/{total}
              </strong>
            </p>
          </div>
        </div>

        {loadingList && (
          <div role="status" aria-live="polite" aria-busy="true" className="space-y-2">
            <span className="sr-only">Carregando lista de desafios</span>
            <ArticlePlaceholder />
            <ArticlePlaceholder />
          </div>
        )}

        {!loadingList && (
          <ul
            id="challenge-list"
            role="tabpanel"
            aria-label="Lista de desafios"
            aria-labelledby={`tab-${params?.id}`}
            tabIndex={-1}
            ref={tabPanelRef}
            className="space-y-5"
          >
            {list?.map((item: any) => (
              <li
                key={item._id}
                className="bg-maastricht-blue p-10 rounded-xl"
                aria-label={`Desafio: ${item.challenge}. Progresso: ${getProgressText(item)}`}
              >
                <article>
                  <div className="flex items-center justify-between border-b border-[#072E4A] border-solid pb-5">
                    <h2 className="text-lg text-electric-blue">{item.challenge}</h2>

                    <div className="flex items-center space-x-4 font-thin">
                      <span aria-hidden="true">
                        <strong>{item.completed ? getTotal(item) : verifyRules(item)}</strong>/{getTotal(item)}
                      </span>
                      <span className="sr-only">{getProgressText(item)}</span>
                      <div
                        className={`${item.completed ? 'bg-electric-blue' : 'bg-prussian-blue-2'} rounded-full bg-electric-blue h-8 w-8 flex justify-center items-center`}
                        role="img"
                        aria-label={item.completed ? 'Desafio concluído' : 'Desafio em andamento'}
                      >
                        <BsCheck
                          className={`${item.completed ? 'text-maastricht-blue-3' : 'text-[#4C6E86]'}`}
                          size={30}
                          aria-hidden="true"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="mt-5 font-thin html-item"
                    dangerouslySetInnerHTML={{
                      __html: item.description,
                    }}
                  />
                </article>
              </li>
            ))}
          </ul>
        )}
      </main>
    </>
  );
}
